import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { AddJobInitialValues } from '../../../../initial-values';
import { AddJobDto } from '../../../../types';
import 'react-datepicker/dist/react-datepicker.css';
import xIcon from '../../../../assets/icons/new_icon/x.svg';
import { addJob } from '../../../../api/admin';
import SelectProjectDropdown from '../../../../components/global-components/SelectProjectDropdown';

interface Props {
  onClose: any;
  onSuccess: any;
  editData?: any;
}

export default function AddJobModal({ onClose, onSuccess, editData }: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<AddJobDto>(AddJobInitialValues);

  const handleAction = () => {
    setLoading(true);
    const filteredData = Object.fromEntries(
      Object.entries(formData).filter(([_, value]) => value !== '')
    );
    addJob(filteredData)
      .then((response) => {
        if (!response.data.is_error) {
          enqueueSnackbar('Job has been added.', {
            variant: 'success',
          });
          onSuccess();
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className='modal'
      id='project_modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      tabIndex={-1}
      aria-labelledby='project_modal_label'
      aria-hidden='true'
      onClick={handleClose}
    >
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      <div className='modal-dialog modal-md'>
        <div className='modal-content'>
          <div className='modal-header d-flex w-100 justify-content-between px-3 py-2'>
            <h3 className='newubbemodalheading  mb-0'>Job Details</h3>
            <img
              alt='X'
              src={xIcon}
              onClick={() => onClose()}
              style={{ cursor: 'pointer' }}
            />
          </div>

          <div className='modal-body'>
            <div className='mb-3'>
              <label htmlFor='carrier' className=' globalInputLabel'>
                Project
              </label>
              <SelectProjectDropdown
                selectedProject={formData?.project_code}
                className={'form-control p-0'}
                setSelectedProject={(val: any) => {
                  setFormData({
                    ...formData,
                    project_code: val,
                  });
                }}
              />
            </div>
            <div className='mb-3'>
              <label htmlFor='reference_one' className=' globalInputLabel'>
                Reference One
              </label>
              <input
                type='text'
                className={'form-control ubbe-input'}
                id='reference_one'
                placeholder='Ex: BOL, Internal Tracking, Etc.'
                autoComplete='new-password'
                value={formData.reference_one}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    reference_one: e.target.value,
                  });
                }}
              />
            </div>
            <div className='mb-3'>
              <label htmlFor='reference_two' className=' globalInputLabel'>
                Reference Two
              </label>
              <input
                type='text'
                className={'form-control ubbe-input'}
                id='reference_two'
                placeholder='Ex: BOL, Internal Tracking, Etc.'
                autoComplete='new-password'
                value={formData.reference_two}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    reference_two: e.target.value,
                  });
                }}
              />
            </div>
            <div className='mb-3'>
              <label htmlFor='purchase_order' className=' globalInputLabel'>
                Purchase Order
              </label>
              <input
                type='text'
                className={'form-control ubbe-input'}
                id='purchase_order'
                placeholder='Ex: PO-123456789'
                autoComplete='new-password'
                value={formData.purchase_order}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    purchase_order: e.target.value,
                  });
                }}
              />
            </div>
          </div>
          <div className='row mt-3 mb-2'>
            <div className='col-sm-12'>
              <p
                className='btn ubbe-blue-bg p-2 px-4 w-100 rounded-3 text-light d-flex m-auto justify-content-center align-items-center mb-2'
                style={{ maxWidth: 'max-content', height: '48px' }}
                onClick={() => {
                  handleAction();
                }}
              >
                Save
              </p>
              <u
                className='m-auto d-flex justify-content-center labelText'
                style={{ cursor: 'pointer' }}
                aria-label='Close'
                onClick={() => onClose()}
              >
                Cancel
              </u>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
